import { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast, Toaster } from "sonner";
import { Trash2, UserPlus } from "lucide-react";

const Enrollments = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/admin/enrollments").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (it, s) => {
    await api.put(`/admin/enrollments/${it.id}`, { ...it, status: s });
    toast.success("Status aktualisiert");
    load();
  };
  const remove = async (it) => {
    if (!window.confirm("Wirklich löschen?")) return;
    await api.delete(`/admin/enrollments/${it.id}`);
    load();
  };
  const convert = async (it) => {
    if (!window.confirm(`${it.student_first_name} ${it.student_last_name} als Schüler übernehmen?`)) return;
    try {
      const r = await api.post(`/admin/enrollments/${it.id}/convert`);
      toast.success(r.data.matched_course
        ? "Als Schüler übernommen (Kurs automatisch zugewiesen)"
        : "Als Schüler übernommen – Kurs bitte manuell zuweisen");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Fehler beim Übernehmen");
    }
  };

  const filtered = filter === "all" ? items : items.filter(i => i.status === filter);

  return (
    <div className="space-y-6" data-testid="admin-enrollments">
      <Toaster position="top-center" theme="light" />
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-serif-display text-3xl">Anmeldungen</h1>
        <select value={filter} onChange={e => setFilter(e.target.value)} className="bg-input/30 border border-border rounded-md px-3 py-2 text-sm">
          <option value="all">Alle</option>
          <option value="new">Neu</option>
          <option value="accepted">Angenommen</option>
          <option value="rejected">Abgelehnt</option>
        </select>
      </div>

      <div className="card-academy rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/40 border-b border-border">
              <tr>
                {["Datum", "Schüler", "Bereich", "Kurs", "Eltern", "Kontakt", "Status", "Aktion"].map(h => (
                  <th key={h} className="text-left text-xs uppercase tracking-[0.15em] text-muted-foreground px-4 py-3">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(it => (
                <tr key={it.id} className="border-b border-border/50">
                  <td className="px-4 py-3 text-xs text-muted-foreground">{(it.created_at || "").substring(0, 10)}</td>
                  <td className="px-4 py-3">{it.student_first_name} {it.student_last_name}</td>
                  <td className="px-4 py-3 capitalize">{it.category}</td>
                  <td className="px-4 py-3">{it.course}</td>
                  <td className="px-4 py-3">{it.parent_name}</td>
                  <td className="px-4 py-3 text-xs"><div>{it.email}</div><div className="text-muted-foreground">{it.phone}</div></td>
                  <td className="px-4 py-3">
                    <select value={it.status || "new"} onChange={e => setStatus(it, e.target.value)} className="bg-input/30 border border-border rounded-md px-2 py-1 text-xs">
                      <option value="new">Neu</option>
                      <option value="accepted">Angenommen</option>
                      <option value="rejected">Abgelehnt</option>
                    </select>
                  </td>
                  <td className="px-4 py-3 flex items-center gap-2">
                    {!it.student_id && (
                      <button
                        onClick={() => convert(it)}
                        data-testid={`enroll-convert-${it.id}`}
                        title="Als Schüler übernehmen"
                        className="inline-flex items-center gap-1 text-xs text-primary hover:underline"
                      >
                        <UserPlus className="w-4 h-4" />Übernehmen
                      </button>
                    )}
                    {it.student_id && <span className="text-xs text-muted-foreground">Übernommen</span>}
                    <button onClick={() => remove(it)} className="text-muted-foreground hover:text-destructive ml-1"><Trash2 className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (<tr><td colSpan={8} className="px-4 py-8 text-center text-muted-foreground">Keine Anmeldungen</td></tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Enrollments;
